// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sem-cadastral-parcel-control {
  width: 100%;
  margin-top: 10px;
}

.cadastral-inputs-container {
  display: flex;
  align-items: stretch;
  gap: 15px;
  flex-wrap: nowrap;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  min-height: 48px;
}


/* Katastrska občina section */
.ko-input-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.ko-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 0;
  white-space: nowrap;
}

.ko-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  text-align: left;
  min-height: 40px;
}

.ko-input:focus {
  outline: none;
  border-color: #007bff;
}

/* Municipality name input section */
.municipality-name-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  min-width: unset;
  max-width: unset;
}

.municipality-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 0;
  white-space: nowrap;
}

.municipality-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.municipality-input {
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
  min-height: 40px;
  text-align: left;
}

.loader {
  position: absolute;
  right: 10px;
  left: auto;
  display: flex;
  align-items: center;
  width: 30px;
  height: 30px;
}

.spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.municipality-input.has-value {
  color: #333;
  font-weight: 500;
  background-color: #e9ecef;
}

.municipality-input:focus {
  outline: none;
  border-color: #007bff;
}



/* Responsive design */
@media (max-width: 768px) {
  .cadastral-inputs-container {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .ko-input-group {
    justify-content: space-between;
    width: 100%;
  }

  .ko-input {
    flex: 1;
    max-width: 150px;
    margin-left: auto;
  }

  .municipality-name-group {
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
}

/* Disabled state */
.cadastral-inputs-container:has(.ko-input:disabled) {
  background-color: #f8f9fa;
  color: #6c757d;
}

.ko-input:disabled,
.municipality-input {
  background-color: #e9ecef;
  opacity: 1;
}

/* Focus within state for better UX */
.cadastral-inputs-container:focus-within .municipality-input.has-value {
  border-color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-cadastral-parcel-control/sem-cadastral-parcel-control.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;;;AAIA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,OAAO;IACP,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;AACvB","sourcesContent":[".sem-cadastral-parcel-control {\r\n  width: 100%;\r\n  margin-top: 10px;\r\n}\r\n\r\n.cadastral-inputs-container {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 15px;\r\n  flex-wrap: nowrap;\r\n  padding: 8px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  background-color: #fff;\r\n  min-height: 48px;\r\n}\r\n\r\n\r\n/* Katastrska občina section */\r\n.ko-input-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  flex: 1;\r\n}\r\n\r\n.ko-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ko-input {\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  text-align: left;\r\n  min-height: 40px;\r\n}\r\n\r\n.ko-input:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n}\r\n\r\n/* Municipality name input section */\r\n.municipality-name-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  flex: 1;\r\n  min-width: unset;\r\n  max-width: unset;\r\n}\r\n\r\n.municipality-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.municipality-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.municipality-input {\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  font-size: 14px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  background-color: #f8f9fa;\r\n  color: #6c757d;\r\n  cursor: not-allowed;\r\n  min-height: 40px;\r\n  text-align: left;\r\n}\r\n\r\n.loader {\r\n  position: absolute;\r\n  right: 10px;\r\n  left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.spinner {\r\n  border: 2px solid #f3f3f3;\r\n  border-top: 2px solid #007bff;\r\n  border-radius: 50%;\r\n  width: 16px;\r\n  height: 16px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.municipality-input.has-value {\r\n  color: #333;\r\n  font-weight: 500;\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.municipality-input:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n}\r\n\r\n\r\n\r\n/* Responsive design */\r\n@media (max-width: 768px) {\r\n  .cadastral-inputs-container {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 10px;\r\n  }\r\n\r\n  .ko-input-group {\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n\r\n  .ko-input {\r\n    flex: 1;\r\n    max-width: 150px;\r\n    margin-left: auto;\r\n  }\r\n\r\n  .municipality-name-group {\r\n    min-width: unset;\r\n    max-width: unset;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Disabled state */\r\n.cadastral-inputs-container:has(.ko-input:disabled) {\r\n  background-color: #f8f9fa;\r\n  color: #6c757d;\r\n}\r\n\r\n.ko-input:disabled,\r\n.municipality-input {\r\n  background-color: #e9ecef;\r\n  opacity: 1;\r\n}\r\n\r\n/* Focus within state for better UX */\r\n.cadastral-inputs-container:focus-within .municipality-input.has-value {\r\n  border-color: #007bff;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
